var map = {
	"./dlpk/contract.json": 771,
	"./dlpk/dashboard.json": 772,
	"./dlpk/login.json": 773,
	"./dlpk/menu.json": 774,
	"./dlpk/party.json": 775,
	"./dlpk/product.json": 776,
	"./dlpk/quotation.json": 777,
	"./dlpk/survey.json": 778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 770;